<div fxLayoutAlign="center center" class="occupy-space">
  <mat-spinner diameter="80" />
</div>
